import React from "react"

const BackgroundCheckStepper = ({ steps, currentStep }) => {
    const totalSteps = steps.length
    const nextStep = currentStep + 1 < totalSteps ? currentStep + 1 : currentStep

    return (
        <div className="bg-background-section shadow-md rounded-lg py-6 px-4 w-full mx-auto">
            <div className="sm:hidden w-full text-center">
                <div className="text-base font-semibold text-text-base mb-4">
                    {steps[currentStep]}
                </div>
                <div className="flex items-center justify-center w-full px-4">
                    <div className="w-8 h-8 rounded-full border-2 border-primary bg-white text-primary flex items-center justify-center text-sm font-semibold">
                        {currentStep + 1}
                    </div>
                    <div className="flex-1 h-0.5 bg-border mx-2" />
                    <div className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-sm font-semibold
                        ${nextStep === currentStep
                            ? "border-border text-border bg-white"
                            : "border-primary text-primary bg-white"
                        }`}
                    >
                        {nextStep + 1}
                    </div>
                </div>
            </div>
            <div className="hidden sm:flex flex-wrap justify-center gap-x-4 gap-y-6 mt-4">
                {steps.map((step, index) => (
                    <div key={index} className="flex items-center">
                        <div className="flex flex-col items-center relative">
                            <div
                                className={`w-8 h-8 rounded-full flex items-center justify-center z-10 text-sm font-semibold
                                    ${index < currentStep
                                        ? "bg-secondary text-white"
                                        : index === currentStep
                                            ? "border-2 border-secondary text-secondary"
                                            : "border-2 border-border text-border bg-white"
                                    }`}
                            >
                                {index + 1}
                            </div>
                            <div className="text-sm mt-2 text-center w-20 truncate text-text-medium">
                                {step}
                            </div>
                        </div>
                        {index !== steps.length - 1 && (
                            <div className="w-8 h-1 bg-border mx-2 hidden sm:block mb-6">
                                <div className={`h-1 ${index < currentStep ? "bg-secondary" : ""}`} />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BackgroundCheckStepper
